export default "__VITE_ASSET__B6XT_rzU__"